// src/components/button/ToggleOrder.tsx

import { ArrowDropDownTwoTone, ArrowDropUpTwoTone } from '@mui/icons-material'
import { IconButton, Tooltip } from '@mui/material'
import { useEffect, useState } from 'react'

import { ASC, DESC } from '../../api'

type Props = {
  onChange: (order: string) => void
  order: string
}

export const ToggleOrder = ({ onChange, order: initialOrder }: Props) => {
  const [order, setOrder] = useState(initialOrder)
  const toggle = () => setOrder(prev => (prev === ASC ? DESC : ASC))

  const icon = order === ASC ? <ArrowDropUpTwoTone /> : <ArrowDropDownTwoTone />
  const tooltip = order === ASC ? 'Sortieren: A-Z' : 'Sortieren: Z-A'

  useEffect(() => onChange(order), [onChange, order])

  return (
    <Tooltip title={tooltip}>
      <IconButton onClick={toggle} sx={{ m: 0 }}>
        {icon}
      </IconButton>
    </Tooltip>
  )
}
